import _HELPERS from './helpers.js';

(async function () {

  const OPTIONS = ('options' in document.currentScript.dataset?document.currentScript.dataset.options:{});
  const SETTINGS = ('settings' in document.currentScript.dataset?document.currentScript.dataset.settings:{});
  const PAGE = ('page' in document.currentScript.dataset?document.currentScript.dataset.page:{});
  const ALIAS = ('alias' in document.currentScript.dataset?document.currentScript.dataset.alias:'js_helper');
  const LOADER_ALIAS = ('loader_alias' in document.currentScript.dataset?document.currentScript.dataset.loader_alias:'');
  const SUCCESSEVENTNAME = ('successEventName' in document.currentScript.dataset?document.currentScript.dataset.successEventName:false);

  const helpersHandler = {
    _hasSetup:false,
    _helpers:{},
    isReady: function()
    {
      if(!('ready' in this))
      {
        this.ready=false;
      }
      return this.ready;
    },

    onReady: function(callback)
    {
      if(typeof callback === 'function')
      {
        this.onReady_callback=callback;
      }
      else
      {
        this._log('error','onReady','Callback not a function',callback);
      }
    },

    init:function(parent){
      this._parent=parent;
      this._hasSetup=false;
      let _this = this;
      if('_log' in this._parent)
      {
        this._log=function(type,source,message,data='')
        {
          _this._parent._log(type,source,message,data,ALIAS);
        };
      }
      else
      {
        this._log = function(type,source,message,data=''){
          console[type](ALIAS+'::'+source+' - '+message,data);
        };
      }
    },

    setup:function()
    {
        try
        {
          if(!this._hasSetup)
          {
            let _this = this;
            _this._hasSetup=true;

            let function__onload = function()
            {
              try
              {
                let options = {};
                let helper_settings={'_log':_this._log};
                try
                {
                  options = JSON.parse(OPTIONS);
                }
                catch(ex)
                {
                  _this._log('error','setup','Error loading OPTIONS settings from attr',ex);
                  options={};
                }
                try
                {
                  helper_settings.page = JSON.parse(PAGE);
                }
                catch(ex)
                {
                  _this._log('error','setup','Error loading PAGE settings from attr',ex);
                  helper_settings.page={};
                }
                try
                {
                  helper_settings.settings = JSON.parse(SETTINGS);
                }
                catch(ex)
                {
                  _this._log('error','setup','Error loading SETTINGS settings from attr',ex);
                  helper_settings.settings={};
                }
                window[ALIAS] = new _HELPERS(helper_settings);
                _this._log('debug','setup','Loading helpers ...',options);
                let insert_count = 0;
                if(typeof options === 'object')
                {
                  if('options' in options && Array.isArray(options.options))
                  {
                    options=options.options;
                  }

                  for(let i=0;i<options.length;i++)
                  {
                    if(typeof options[i] === 'object' && 'key' in options[i])
                    {
                      let option_settings = {};
                      let helper_settings = {};
                      if(Array.isArray(options[i].settings))
                      {
                        for(let ii=0;ii<options[i].settings.length;ii++)
                        {
                          if(('key' in options[i].settings[ii]) && ('value' in options[i].settings[ii]))
                          {
                            if(options[i].settings[ii].key.startsWith('@'))
                            {
                              helper_settings[options[i].settings[ii].key.substring(1)]=options[i].settings[ii].value;
                            }
                            else
                            {
                              option_settings[options[i].settings[ii].key]=options[i].settings[ii].value;
                            }
                          }
                        }
                      }

                      if(window[ALIAS].add(options[i].key,options[i].value,option_settings,helper_settings))
                      {
                        _this._log('debug','setup','Created helper '+options[i].name+'('+option_settings.type+') '+options[i].key+' ...');
                        insert_count++;
                      }
                      else
                      {
                        _this._log('debug','setup','Failed to create helper '+options[i].name+'('+option_settings.type+') '+options[i].key+', type not found...');
                      }
                    }
                    else
                    {
                      _this._log('warning','setup','No helpers found');
                    }
                  }
                }
                if(insert_count==0)
                {
                    _this._log('warning','setup','No helpers available');
                }
              }
              catch(ex)
              {
                _this._log('error','setup','Loading helpers failed!',ex);
              }
            };

            if(document.readyState !== 'uninitialized' && document.readyState !== 'loading')
            {
               _this._log('debug','setup','Load event already fired...');
              function__onload();
            }
            else
            {
               _this._log('debug','setup','Waiting for load event...',document.readyState);
              // Everything but IE
              window.addEventListener("load", function() {
              function__onload();
              }, false);
            }
          }
          else
          {
            this._log('warning','setup','Already setup helpers!');
          }
        }
        catch(ex)
        {
          this._log('error','setup','Setup failed!',ex);
        }
    }
  };

  if(typeof window[LOADER_ALIAS] === 'object' && 'registerHandler' in window[LOADER_ALIAS] && typeof window[LOADER_ALIAS].registerHandler === 'function')
  {
    window[LOADER_ALIAS].registerHandler(ALIAS,helpersHandler,async function(me,parent){
      me.init(parent);
      me.setup();
    });
  }
  else
  {
    if(!( ALIAS in window ))
    {
      helpersHandler.init();
      helpersHandler.setup();
    }
    else
    {
      console.debug(LOADER_ALIAS+'/'+ALIAS+':: Looks like window['+ALIAS+'] already exists....skip.');
    }
  }

})();
